export const DEFAULT_USER_PROFILE_IMG_SRC =
  "https://exly-public-content.s3.ap-south-1.amazonaws.com/creator-tool/public/default_user_profile_image.png";
